import { orderBy } from "lodash";
import React from "react";
import { useSelector } from "react-redux";
import { IIngredient56227 } from "../../../common/types";
import { Form, Select } from "../../atoms";
import { UserSelectedFieldWrapper } from "./Fields.style";

interface IIngredientSelectedFieldProps {
  bordered?: boolean;
  name: string | Array<string | number>;
  label?: string;
  rules?: any[];
  placeholder?: string;
  style?: any;
  mode?: "multiple" | "tags";
  maxTagCount?: number;
  initialValue?: any;
  getIngredient?: () => IIngredient56227;
  onChange?: (value: any) => void;
}
export const IngredientSelectedField: React.FC<
  IIngredientSelectedFieldProps
> = ({
  name,
  label,
  mode,
  rules,
  getIngredient,
  onChange,
  bordered = true,
  style,
  placeholder,
  maxTagCount,
  initialValue,
}) => {
  const { ingredient56227 } = useSelector(
    (state: any) => state.ingredient56227
  );

  return (
    <UserSelectedFieldWrapper>
      <Form.Item
        label={label}
        name={name}
        rules={rules}
        initialValue={initialValue}
      >
        <Select
          showSearch
          bordered={bordered}
          style={style}
          placeholder={placeholder || label}
          optionFilterProp="label"
          filterOption={(input, option: any) =>
            option.search.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          options={orderBy(ingredient56227, ["name"], ["asc"]).map(
            (ingredient: IIngredient56227) => ({
              value: ingredient.id,
              label: ingredient.name,
              search: `${ingredient?.name || ""}`,
            })
          )}
          mode={mode}
          maxTagCount={maxTagCount}
          onChange={onChange}
        ></Select>
      </Form.Item>
    </UserSelectedFieldWrapper>
  );
};

export default IngredientSelectedField;
